import React from 'react';
import { connect } from 'react-redux';
import ProgressBar from 'react-bootstrap/ProgressBar';

function Loader({ isLoading, uploadProgress, downloadProgress }) {
    var progress = 0;
    var c = 0;
    if (uploadProgress && uploadProgress > 0) {
        progress += uploadProgress;
        c++;
    }

    if (downloadProgress && downloadProgress > 0) {
        progress += downloadProgress;
        c++;
    }
    if (progress > 0)
        progress /= c;
    return (
        <>
            {/* {uploadProgress && <ProgressBar animated now={progress} />} */}
            {(progress && progress !== 0 && progress !== 100 &&
                <div className="fixed-top">
                    <ProgressBar animated now={progress} />
                </div>) || null}
            {isLoading &&
                <div className="d-flex flex-column align-items-center overlay-center">
                    <div className="row">
                        <div className="spinner-border " role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div className="row">
                        <strong>Collecting data</strong>
                    </div>
                    <div className="row">
                    </div>
                </div>
            }
        </>
    )
    // }
    // else return null
}
const mapStateToProps = ({ reducer }) => ({
    isLoading: reducer.isLoading,
    uploadProgress: reducer.uploadProgress,
    downloadProgress: reducer.downloadProgress
})

export default connect(mapStateToProps)(Loader);
